export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="text-xl font-heading text-white mb-4">吃瓜入口</div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
              聚焦51黑料吃瓜入口、黑料吃瓜在线、51在线吃瓜今日吃瓜入口等热门渠道，
              每日更新独家黑料内容与最新视频，支持黑料视频在线看，
              提供最稳定的黑料吃瓜网入口体验。
            </p>
          </div>
          <div>
            <div className="text-sm font-medium text-white mb-4">快速导航</div>
            <div className="space-y-2">
              {[
                { label: '视频专区', href: '#media' },
                { label: '今日索引', href: '#index' },
                { label: '热度榜单', href: '#ranking' },
                { label: '吃瓜快讯', href: '#updates' }
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="text-sm font-medium text-white mb-4">热门话题</div>
            <div className="space-y-2">
              {['娱乐圈黑料', '财经圈内幕', '网红圈爆料', '直播圈动态'].map((item) => (
                <a
                  key={item}
                  href="#topics"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
          <div>
            <div className="text-sm font-medium text-white mb-4">合作伙伴</div>
            <div className="space-y-2">
              <div className="text-xs md:text-sm text-foreground-500">更多合作伙伴即将加入</div>
              <div className="text-xs md:text-sm text-foreground-500">商务合作请联系投稿邮箱</div>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 吃瓜入口 · 黑料吃瓜网入口 · 51黑料吃瓜入口 · 黑料吃瓜在线
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">返回顶部</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer">投稿爆料</a>
          </div>
        </div>
      </div>
    </footer>
  );
}